<div *ngIf="html" class="wysiwyg-container" [ngClass]="{canCollapse: collapsible, expanded: expanded}">
  <div class="wysiwyg" [innerHTML]="html | safeHtml"></div>
</div>
<button *ngIf="collapsible && !!html?.length" class="button link" (click)="expanded = !expanded">{{expanded ? 'Show Less' : 'Show More'}}</button>
